import axios from '@axios'

export const APP_STORE_MODULE_NAME = 'apps-barcode';
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAllData(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Barcodes/getall`, { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchData(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Barcodes/getbyid?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addNewData(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/Barcodes/add', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateData(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/Barcodes/update', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        suspend(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/Barcodes/suspend?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
